'use client'

import { FC } from 'react'

import { Button, ModalBase } from '@/components/commons'
import { AttentionRoundIcon, CheckRoundIcon } from '@/components/icons'

import { ModalCaseType, ModalProps } from './types'

const Modal: FC<ModalProps> = ({
  isOpenModal,
  setIsOpenModal,
  variant,
  onClick,
  customMessage,
  ...props
}) => {
  function handleCloseModal() {
    setIsOpenModal(false)
  }

  const modalCase: ModalCaseType = {
    success: {
      icon: <CheckRoundIcon className="fill-status-green w-[80px] h-[80px]" />,
      title: <h5 className="prose-headline-h5 text-status-green">Sucesso!</h5>,
      paragraph: (
        <span className="flex w-full flex-col gap-4 items-start">
          <p className="prose-body">A senha foi alterada.</p>
          <p className="prose-body">
            Você será redirecionado para a página de login para fazer um novo
            acesso.
          </p>
        </span>
      ),
      buttons: (
        <Button
          className="w-[158px] self-end"
          text="Ir para Login"
          type="button"
          onClick={onClick}
        />
      ),
    },
    customMessage: {
      icon: (
        <AttentionRoundIcon className="fill-status-red w-[80px] h-[80px]" />
      ),
      title: <h5 className="prose-headline-h5 text-status-red">Atenção</h5>,
      paragraph: (
        <span className="flex w-full flex-col gap-4 items-start">
          {customMessage?.length && Array.isArray(customMessage) ? (
            customMessage?.map((item, index) => (
              <p
                key={`custom-message-form-create-profile-${index}`}
                className="prose-body"
              >
                {item?.message as string}
              </p>
            ))
          ) : customMessage?.length ? (
            <p className="prose-body">{customMessage as string}</p>
          ) : null}
        </span>
      ),
      buttons: (
        <Button
          className="w-[158px]"
          text="Voltar"
          type="button"
          onClick={handleCloseModal}
        />
      ),
    },
  }

  return (
    <ModalBase
      className="w-full max-w-[400px]"
      isOpenModal={isOpenModal}
      {...props}
    >
      <ModalBase.Header>
        {modalCase[variant].icon}
        {modalCase[variant].title}
        {modalCase[variant].paragraph}
      </ModalBase.Header>
      <ModalBase.Footer className="justify-end">
        {modalCase[variant].buttons}
      </ModalBase.Footer>
    </ModalBase>
  )
}

export default Modal
